export enum Constants {
  RESET_AUDIENCE_VIEW_STATE = "app/broadcast/AUDIENCE_VIEW/RESET_AUDIENCE_VIEW_STATE",
  SET_IS_CONTAINER_MOUNTED = "app/broadcast/AUDIENCE_VIEW/SET_IS_CONTAINER_MOUNTED",
  SET_ITEMS_PER_ROW = "app/broadcast/AUDIENCE_VIEW/SET_ITEMS_PER_ROW",
  TOGGLE_EXPAND = "app/broadcast/AUDIENCE_VIEW/TOGGLE_EXPAND",
  UPDATE_SLOTS = "app/broadcast/AUDIENCE_VIEW/UPDATE_SLOTS",
}
